<template>
  <v-chip :close="close"
          :small="small"
          @click:close="$emit('input')">
    <v-avatar>
      <img :src="require(`@/assets/credit_cards_material_design/png/48/${getImageFileName(brand)}.png`)">
    </v-avatar>
    {{ label }}: ***{{ last4Digits}}
  </v-chip>
</template>
<script>
import bankBrandImages from '@/libs/bankBrandImages'
export default {
  data () {
    return {
      getImageFileName: bankBrandImages.getImageFileName
    }
  },
  props: {
    brand: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    last4Digits: {
      type: String,
      required: true
    },
    close: {
      type: Boolean,
      required: false,
      default: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
